// adapterCatalog.js — Web mirror of apolo-api/src/lib/llmAdapterCatalog.js.
//
// Used for: pre-fetch placeholders, kind metadata, request-format constants,
// and any client-only helpers. The DB is the source of truth at runtime
// (ensureBuiltins seeds per-user on first GET /api/adapters).

export const ADAPTER_KINDS = ['text', 'image', 'video', 'audio'];

export const KIND_META = {
  text: { label: 'Texto', icon: '💬', accent: '#737373' },
  image: { label: 'Imagem', icon: '🎨', accent: '#a070c0' },
  video: { label: 'Vídeo', icon: '🎬', accent: '#c07060' },
  audio: { label: 'Áudio', icon: '🎙️', accent: '#60c0a0' },
};

export const REQUEST_FORMATS = [
  'openai-compatible',
  'anthropic',
  'custom',
  'image-gen',
  'video-gen',
  'tts',
];

// Optional client-side preview list (matches built-ins from server lib).
// Not authoritative — used only for offline placeholder rendering when
// /api/adapters has not loaded yet.
export const BUILTIN_PREVIEW = [
  { name: 'anthropic-api', display_name: 'Anthropic', icon: '🟠', kind: 'text' },
  { name: 'openai-api', display_name: 'OpenAI', icon: '⚫', kind: 'text' },
  { name: 'gemini', display_name: 'Google Gemini', icon: '🔵', kind: 'text' },
  { name: 'openrouter', display_name: 'OpenRouter', icon: '🟣', kind: 'text' },
];
